import type { DealInformationTab } from '../../DealInformation/types';

import type { FieldHistoryEntry } from './types';

// Dummy data so the history UI can be reviewed before a history API exists. Delete with the API wiring.
const USER_A = 'Test User A';
const USER_B = 'Test User B';
const USER_C = 'Test User C';
const SYSTEM_USER = 'System';
const ROOM_A = 'Example Standard Room';
const ROOM_B = 'Example Deluxe Suite';

function entry(
  id: string,
  changedAt: string,
  field: string,
  user: string,
  previousValue: string | null,
  newValue: string | null,
): FieldHistoryEntry {
  return { id, changedAt, field, user, previousValue, newValue };
}

// Stamped at load so the report reads "Updated a few seconds ago"
export const MOCK_HISTORY_LAST_UPDATED_AT = new Date().toISOString();

export const MOCK_DETAILS_HISTORY: Array<FieldHistoryEntry> = [
  entry('d1', '2026-09-09T11:02:00', 'Stage', USER_A, 'Qualification', 'Closed Won'),
  entry('d2', '2026-09-09T10:48:00', 'Close Date', USER_A, null, '1/01/2026'),
  entry('d3', '2026-09-08T16:16:00', 'Cost Price Currency', USER_B, 'AUD', 'USD'),
  entry('d4', '2026-09-08T15:40:00', 'Includes Solo Traveler Packages', USER_B, 'Yes', 'No'),
  entry('d5', '2026-09-08T14:15:00', 'Opportunity Record Type', USER_B, 'Example Type 1', 'Example Type 2'),
  entry('d6', '2026-09-07T16:40:00', 'Planned End Date (LE)', SYSTEM_USER, '1/01/2026', '2/01/2026'),
  entry('d7', '2026-09-07T16:03:00', 'Planned Run Date (LE)', USER_C, '3/01/2026', '4/01/2026'),
  entry('d8', '2026-09-07T15:26:00', 'Production Stages', USER_B, 'Example Stage 1', 'Example Stage 2'),
  entry('d9', '2026-09-07T14:49:00', 'Record unlocked', USER_A, null, null),
  entry('d10', '2026-09-07T14:12:00', 'Deal Tier', USER_C, 'Example Tier 3', 'Example Tier 2'),
  entry('d11', '2026-09-07T13:35:00', 'Payment Method', USER_B, 'Example Method 1', 'Example Method 2'),
  entry('d12', '2026-09-07T12:58:00', 'Weighting', SYSTEM_USER, '0.50', '1.00'),
];

export const MOCK_DEAL_HISTORY_BY_TAB: Record<
  Exclude<DealInformationTab, 'campaign-schedules'>,
  Array<FieldHistoryEntry>
> = {
  details: MOCK_DETAILS_HISTORY,
  'deal-options': [
    entry('o1', '2026-09-12T14:11:00', `2N ${ROOM_A} · Allocation`, USER_A, '5', '3'),
    entry('o2', '2026-09-12T14:09:00', `3N ${ROOM_A} · Number of extra nights`, USER_A, '0', '1'),
    entry('o3', '2026-09-10T09:22:00', `2N ${ROOM_B} · Allocation`, USER_C, '2', '3'),
  ],
  inclusions: [
    entry(
      'i1',
      '2026-09-14T11:36:00',
      `${ROOM_A} · 2N ${ROOM_A} inclusions`,
      USER_A,
      'Example Inclusion 1',
      'Example Inclusion 1, Example Inclusion 2, Example Inclusion 3',
    ),
  ],
  egs: [
    entry('e1', '2026-09-15T15:05:00', 'Child 3–17 yrs · Cost', USER_A, 'US$10', 'US$15'),
    entry('e2', '2026-09-11T10:14:00', 'EGS entry', USER_C, null, 'Infant 0–2 yrs · Free of Charge'),
  ],
  surcharges: [
    entry('s1', '2026-09-16T13:48:00', 'Example Season · Sell price', USER_A, 'A$100', 'A$110'),
    entry('s2', '2026-09-07T16:02:00', 'Surcharge', USER_B, null, 'Example Event · 1 Jan 2027 – 8 Jan 2027'),
  ],
  'blackout-dates': [
    entry('b1', '2026-09-06T09:20:00', 'Example Holiday · Rooms', USER_A, ROOM_A, 'All rooms (6)'),
    entry('b2', '2026-09-06T09:18:00', 'Blackout', USER_A, null, 'Example Holiday · 24 Dec 2026 – 26 Dec 2026'),
  ],
  'bundled-experiences': [
    entry('x1', '2026-09-13T17:28:00', 'Example Experience 3-Day Pass Adult · Uplift', USER_B, 'US$18.00', 'US$22.50'),
    entry(
      'x2',
      '2026-09-13T17:22:00',
      `2N ${ROOM_A} · Bundled experience`,
      USER_A,
      null,
      'Example Experience 3-Day Pass Adult',
    ),
  ],
};

export const MOCK_ACCOUNT_HISTORY: Array<FieldHistoryEntry> = [
  entry('a1', '2026-09-08T11:54:00', 'Australia Business Number', SYSTEM_USER, '00000000001', '00000000002'),
  entry('a2', '2026-02-03T14:56:00', 'AUS Bank Account Name', SYSTEM_USER, 'Example Hotel Pty Ltd', 'Example Hotel'),
  entry('a3', '2025-03-28T14:26:00', 'Account Weighting', USER_C, null, '1'),
  entry('a4', '2026-09-09T10:48:00', 'Opportunity', USER_A, null, 'Example Hotel Gold Experience'),
  entry('a5', '2026-04-10T09:12:00', 'Asset', USER_B, null, ROOM_A),
  entry('a6', '2026-03-04T15:18:00', 'Contact', USER_A, null, 'Test Contact'),
];
